import React from "react";
import "./QuestionDisplay.css";

function QuestionDisplay({ question }) {
  if (!question) return null;

  return (
    <div className="question-display">
      <h2>{question.title}</h2>
      <div className="question-text">
        {question.question.split("\n").map((line, i) => (
          <p key={i}>{line}</p>
        ))}
      </div>

      {question.tables && question.tables.length > 0 && (
        <div className="tables-section">
          <h3>Tables</h3>
          <div className="tables-container">
            {question.tables.map((table) => (
              <div key={table.name} className="table-container">
                <h4>{table.name}</h4>
                <table className="schema-table">
                  <thead>
                    <tr>
                      <th>Column Name</th>
                      <th>Data Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {table.columns.map((col, idx) => (
                      <tr key={idx}>
                        <td>{col.name}</td>
                        <td className="column-type">{col.type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default QuestionDisplay;
